export default __webpack_public_path__ + "static/media/pfp1.394c20a6.png";